import { ButtonOptionSelector } from "@portal/components/atoms/buttonOptionSelector";
import { OnNumMonthsChange } from "../../../components/handlers";
import { IButtonOptionsProps } from "../types";
import Typography from "@portal/components/atoms/v2/typography";

export const ButtonOptions = ({
  options,
  header,
  selectedItem,
  setSelectedItem,
  setNumOfMonthsStartupAmount,
}: IButtonOptionsProps) => {
  const handleChange = (i: number) => {
    setSelectedItem(i);
    OnNumMonthsChange(i, setNumOfMonthsStartupAmount);
  };

  return (
    <>
      <div className="flex mt-5">
        <Typography variant="Bold">{header}</Typography>
      </div>
      <div>
        <ButtonOptionSelector
          options={options.map((o, i) => (
            <Typography key={i}>{o}</Typography>
          ))}
          selectedItem={selectedItem}
          handleChange={handleChange}
        />
      </div>
    </>
  );
};
